/**
 * tailwind-variants bound to a twMerge that knows our custom utilities.
 *
 * tailwind-merge cannot read the stylesheet. Colour utilities it still resolves
 * from their prefix alone, so the semantic names are absent here on purpose;
 * the shadow, drop-shadow and font-size namespaces have to be repeated. Omitting
 * one is silent, not an error: `shadow-<unknown>` is parsed as a shadow *colour*,
 * so it never conflicts with a real shadow, both classes survive the merge, and
 * the cascade — not variant precedence — picks the winner. `tv.test.ts` derives
 * the names from the CSS and fails on any omission.
 */
import { createTV } from "tailwind-variants";

// tailwind-merge's arbitrary-shadow detector only recognizes values starting
// with `inset`/lengths, so `shadow-[var(--shadow-*),…]` composites would fall
// into the shadow-color group and never conflict with the named tokens below.
const isThemeTokenShadow = (value: string) => /^\[var\(--shadow-/.test(value);

export const tv = createTV({
  twMergeConfig: {
    extend: {
      classGroups: {
        "drop-shadow": [{ "drop-shadow": ["iphone-mockup", "popover", "sticker-soft", "sticker-layered"] }],
        "font-size": [
          {
            text: ["display-xs", "display-sm", "display-md", "display-lg", "display-xl", "display-2xl", "display-3xl"],
          },
        ],
        shadow: [
          {
            shadow: [
              "xs",
              "sm",
              "md",
              "lg",
              "xl",
              "2xl",
              "3xl",
              "skeumorphic",
              "xs-skeumorphic",
              "modern-mockup-inner-sm",
              "modern-mockup-inner-md",
              "modern-mockup-inner-lg",
              "modern-mockup-outer-md",
              "modern-mockup-outer-lg",
              "card",
              "chip",
              "sheet",
              "keyline",
              "keyline-inset",
              "focus-ring",
              "focus-ring-error",
              "focus-ring-success",
              isThemeTokenShadow,
            ],
          },
        ],
      },
    },
  },
});

export type { VariantProps } from "tailwind-variants";
